import { Component } from 'react'

class Location extends Component {
  componentDidMount() {
    const { to, replace } = this.props

    if (replace) {
      return window.location.replace(to)
    }

    window.location.href = to
  }

  render() {
    return null
  }
}

export default Location



// WEBPACK FOOTER //
// ./src/components/Location.js